/// simulate session timelife on browser use sessionStorage

import { browser } from '$app/environment';

/** Local session
 *
 */
export const useLocalSession = <T = any>(sname: string) => {
	type Key = keyof T;

	const invoke = (): T | null => {
		if (!browser) return null;
		const data = sessionStorage.getItem(sname);
		if (!data) return null;

		return JSON.parse(data) as T;
	};

	const reset = <T2 extends T>(t: T2) => {
		if (!browser) return;
		sessionStorage.setItem(sname, JSON.stringify(t));
	};

	const del = () => {
		if (!browser) return;
		sessionStorage.removeItem(sname);
	};

	const delKey = <K extends Key>(name: K) => {
		if (!browser) return;
		const data = invoke();
		if (!data) return;
		delete data[name];
		reset(data);
	};

	const set = <K extends Key>(name: K, value: T[K]) => {
		if (!browser) return;
		const data = invoke() || ({} as T);
		data[name] = value;
		reset(data);
	};

	const get = <K extends Key>(name: K): T[K] | null => {
		if (!browser) return null;
		const data = invoke();
		if (!data) return null;
		return data[name];
	};

	return {
		invoke,
		reset,
		del,
		set,
		get,
		delKey
	};
};
